import { MASTER_HOME } from "../../helpers/masterUser";

export const MASTER_NAV_SECTIONS = [
	{
		titleKey: "master.nav.sectionOverview",
		items: [
			{
				to: MASTER_HOME,
				match: (pathname) => pathname === MASTER_HOME,
				labelKey: "master.nav.dashboard",
				icon: "dashboard",
			},
			{
				to: `${MASTER_HOME}/companies`,
				match: (pathname) =>
					pathname === `${MASTER_HOME}/companies` ||
					pathname.startsWith(`${MASTER_HOME}/companies/`),
				labelKey: "master.nav.companies",
				icon: "companies",
			},
			{
				to: `${MASTER_HOME}/busca/usuarios-por-empresa`,
				match: (pathname) =>
					pathname === `${MASTER_HOME}/busca/usuarios-por-empresa`,
				labelKey: "master.nav.searchUsers",
				icon: "users",
			},
		],
	},
	{
		titleKey: "master.nav.sectionCommercial",
		items: [
			{
				to: `${MASTER_HOME}/plans`,
				match: (pathname) => pathname === `${MASTER_HOME}/plans`,
				labelKey: "master.nav.plans",
				icon: "plans",
			},
			{
				to: `${MASTER_HOME}/addons`,
				match: (pathname) => pathname === `${MASTER_HOME}/addons`,
				labelKey: "master.nav.addons",
				icon: "addons",
			},
			{
				to: `${MASTER_HOME}/coupons`,
				match: (pathname) => pathname === `${MASTER_HOME}/coupons`,
				labelKey: "master.nav.coupons",
				icon: "coupons",
			},
			{
				to: `${MASTER_HOME}/finance`,
				match: (pathname) => pathname === `${MASTER_HOME}/finance`,
				labelKey: "master.nav.finance",
				icon: "finance",
			},
		],
	},
	{
		titleKey: "master.nav.sectionSystem",
		items: [
			{
				to: `${MASTER_HOME}/system`,
				match: (pathname) => pathname === `${MASTER_HOME}/system`,
				labelKey: "master.nav.system",
				icon: "system",
			},
			{
				to: `${MASTER_HOME}/documents`,
				match: (pathname) =>
					pathname === `${MASTER_HOME}/documents` ||
					pathname.startsWith(`${MASTER_HOME}/documents/`),
				labelKey: "master.nav.documents",
				icon: "docs",
			},
		],
	},
	{
		titleKey: "master.nav.sectionLogs",
		items: [
			{
				to: `${MASTER_HOME}/agendamentos/logs`,
				match: (pathname) =>
					pathname === `${MASTER_HOME}/agendamentos/logs` ||
					pathname.startsWith(`${MASTER_HOME}/agendamentos/logs/`),
				labelKey: "master.nav.scheduleLogs",
				icon: "logs",
			},
			{
				to: `${MASTER_HOME}/envio-massa/logs`,
				match: (pathname) =>
					pathname === `${MASTER_HOME}/envio-massa/logs` ||
					pathname.startsWith(`${MASTER_HOME}/envio-massa/logs/`),
				labelKey: "master.nav.bulkMessagingLogs",
				icon: "logs",
			},
		],
	},
];

/** Lista plana (compatibilidade com consumidores antigos). */
export const MASTER_NAV_ITEMS = MASTER_NAV_SECTIONS.flatMap((section) => section.items);
